import React, { useEffect, useState } from "react";
import "./style.css";
import img from "../../../Assets/SharedStyle/Shoman & Arab Bank - logos - Final-02.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import LogOutServices from "../../../Services/Account/LogOutServices";
import loadConfig from "../../../Services/Api/ApiServices";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { ChangeApplicationStatus } from "../../../Redux/Reducers/Shared/ApplicationInformation";
import { decryptToken } from "../../../Services/Encryption/EncryptionParams";

const Header = (props) => {
  const match = window.location.pathname; // قراءة النص بعد أول "/"
    const encryptedToken = match.split("/");
      var guid =
        encryptedToken[encryptedToken.length - 1] != null
          ? decryptToken(encryptedToken[encryptedToken.length - 1])
          : null;
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  const [dataJsonObject, SetDataJsonObject] = useState();
  // malek1SRFundsTest@gmail.com
  const state = useSelector((state) => {
    return {
      UserInfo: state.UserInfo.UserInfo.userToken,
      //   RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
      //   ApplicationInformation:
      //     state.ApplicationInformation.ApplicationInformation,
    };
  });
  const dispatch = useDispatch();
  //get user inormation
  const [userInfo, setUserinfo] = useState({
    ...state.UserInfo?.userToken?.userToken,
  });

  const navigate = useNavigate();

  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);

    //console.log(jsonData, "jsonDataaa");
  };
// console.log(state.UserInfo.userType="Employee","ssssssssssssssdwd");

  //to get data json from main.js
  useEffect(() => {
    dataJson();
  }, []);

  const ReturnApplicationToEdit = () => {
    dispatch(
      ChangeApplicationStatus({
        applicationInfoId: guid,
        statusId: "57ca8392-5b8e-4625-8a37-00dfc27d5b28",
      })
    );
  };
  console.log(ApplicationInformation?.applicationStatusId, "ssssssdwdwdwd");

  return (
    <div className="headerPage">
      <div className="Left">
        <>
          <div className="homeLogoAndText">
            {localStorage.getItem("ApplicationInformationId") ? (
              <>
                <span>
                  <span
                    className="LogoHome"
                    onClick={() => {
                      if (window.location.href.includes("manager")) {
                        window.location.replace(
                          "/grants_/manager/RequestsManager"
                        );
                      } else {
                        window.location.replace("/SRFund/mainpage");
                      }
                    }}
                  >
                    الرئيسية
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-house"
                    viewBox="0 0 16 16"
                    onClick={() => {
                      if (window.location.href.includes("manager")) {
                        window.location.replace(
                          "/grants_/manager/RequestsManager"
                        );
                      } else {
                        window.location.replace("/SRFund/mainpage");
                      }
                    }}
                  >
                    <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
                  </svg>
                </span>
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="NameUserTextAndLogo">
            <span>
              <span className="userName">{state.UserInfo?.userNameEN}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-people"
                viewBox="0 0 16 16"
              >
                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
              </svg>
            </span>
          </div>
          <div className="LogOutLogoAndText">
            <span>
              <span className="LogoLogOut" onClick={LogOutServices}>
                خروج
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-box-arrow-in-right"
                viewBox="0 0 16 16"
                onClick={LogOutServices}
              >
                <path
                  fill-rule="evenodd"
                  d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
                />
                <path
                  fill-rule="evenodd"
                  d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                />
              </svg>
            </span>
          </div>
          <div>
            {ApplicationInformation?.applicationStatusId ===
            "521bf595-b593-4551-a2b6-8fb3719314de" &&state.UserInfo.userType=="Employee"? (
              <button
                className="ReturnApplicationToEdit"
                onClick={ReturnApplicationToEdit}
              >
                ارجاع الطلب للتعديل
              </button>
            ) : (
              <></>
            )}

            {/* <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                // SaveDataPage(true);
              }}
              disabled={false}
              title={"ارجاع الطلب للتعديل"}
              text={"ارجاع الطلب للتعديل"}
              show={true}
            /> */}
          </div>
        </>
      </div>

      <div className="LogoImageCenter">
        <img className="logoImage" src={img} />
      </div>

      <div className="Rghit">
        <div></div>

        <div className="containerInfo">
          <div>
            {
              <div className="contactInfo">
                <a target="_blank" href={`tel:${dataJsonObject?.AwardEmail}`}>
                  <span>
                    {dataJsonObject?.AwardNumber}
                    &nbsp;<i class="bi bi-telephone"></i>
                  </span>
                  <span></span>
                </a>
              </div>
            }
          </div>

          <div>
            {
              <div className="contactInfo">
                <a href={`mailto:${dataJsonObject?.AwardEmail}`}>
                  <span>
                    {dataJsonObject?.AwardEmail}
                    &nbsp;<i class="bi bi-envelope"></i>
                  </span>
                  <span></span>
                </a>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
